import { defineNuxtPlugin } from '#app'
import PrimeVue from 'primevue/config'
import { nuxtPrimevueOptions } from '~/vue-components/styles/primevue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Skeleton from 'primevue/skeleton'
import Tooltip from 'primevue/tooltip'
import FocusTrap from 'primevue/focustrap'

export default defineNuxtPlugin({
  name: 'primevuePlugin',
  async setup(nuxtApp) {
    nuxtApp.vueApp.use(PrimeVue, nuxtPrimevueOptions)
    nuxtApp.vueApp.use(ToastService)
    nuxtApp.vueApp.use(ConfirmationService)
    nuxtApp.vueApp.component('Button', Button)
    nuxtApp.vueApp.component('InputText', InputText)
    nuxtApp.vueApp.component('Toast', Toast)
    nuxtApp.vueApp.component('Skeleton', Skeleton)
    nuxtApp.vueApp.directive('tooltip', Tooltip)
    nuxtApp.vueApp.directive('focustrap', FocusTrap)
  },
})
